export const FETCHING_USER_DETAIL = "fetching_user_detail",
  UPDATING_USER_DETAIL = "updating_user_detail",
  USER_DETAIL_SUCCESS = "user_detail_success",
  USER_UPDATE_SUCCESS = "user_update_success",
  USER_DETAIL_FAIL = "user_detail_fail";
